import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
    Component,
    EventEmitter,
    OnInit,
    Output,
    OnDestroy,
    Input,
} from "@angular/core";
import { FiltroOOTT } from "app/main/apps/shared/interfaces/filtro-oott.interface";
import { FormControl } from "@angular/forms";
import { FiltrosService } from "app/main/apps/shared/services/util/filtros.service";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatChipInputEvent } from "@angular/material/chips";
import { Subscription, Observable } from "rxjs";
import { ClienteDTO } from "../../../../shared/interfaces/cliente.interface";
import { startWith, map } from "rxjs/operators";
import { ElementRef, ViewChild } from "@angular/core";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";

import { EstadoDTO } from "app/main/apps/shared/interfaces/estado.interface";
import { CodigoDTO } from "app/main/apps/shared/interfaces/codigo.interface";

@Component({
    selector: "app-filtro-oott",
    templateUrl: "./filtro-oott.component.html",
    styleUrls: ["./filtro-oott.component.scss"],
})
export class FiltroOottComponent implements OnInit, OnDestroy {
    @ViewChild("clienteInput") clienteInput: ElementRef<HTMLInputElement>;
    @ViewChild("estadoInput") estadoInput: ElementRef<HTMLInputElement>;
    @ViewChild("situacionInput") situacionInput: ElementRef<HTMLInputElement>;
    @ViewChild("estadoPagoInput") estadoPagoInput: ElementRef<HTMLInputElement>;


    @Input() clientes: ClienteDTO[];
    @Input() estados: EstadoDTO[];
    @Input() situaciones: CodigoDTO[];
    @Input() setearFiltros: boolean;
    @Input() estadoPago: CodigoDTO[];

    @Output() filtrarOOTT: EventEmitter<FiltroOOTT> = new EventEmitter();
    filtros: FiltroOOTT;
    separatorKeysCodes: number[] = [ENTER, COMMA];
    subscripciones: Subscription;
    nroOOTTCtrl = new FormControl();
    nroTicketCtrl = new FormControl();
    nombreContratistaCtrl = new FormControl();
    rutContratistaCtrl = new FormControl();
    clienteCtrl = new FormControl();
    estadoCtrl = new FormControl();
    situacionCtrl = new FormControl();
    estadoPagoCtrl = new FormControl();

    filteredClientes: Observable<ClienteDTO[]>;
    filteredEstados: Observable<EstadoDTO[]>;
    filteredSituacion: Observable<CodigoDTO[]>;
    filteredEstadoPago: Observable<CodigoDTO[]>;

    constructor(
        private _filtroSrvc: FiltrosService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this.subscripciones = new Subscription();
        this.filtros = this._filtroSrvc.getFiltro("filtrosOOTT");
        //console.log('this.filtros');
        //console.log(this.filtros);

        this.filteredClientes = this.clienteCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "nombre", this.clientes)
                    : this.clientes.slice()
            )
        );

        this.filteredEstados = this.estadoCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "descripcion", this.estados)
                    : this.estados.slice()
            )
        );

        this.filteredSituacion = this.situacionCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "nombre", this.situaciones)
                    : this.situaciones.slice()
            )
        );

        this.filteredEstadoPago = this.estadoPagoCtrl.valueChanges.pipe(
            startWith(null),
            map((value: string | null) =>
                value
                    ? this._filter(value, "nombre", this.estadoPago)
                    : this.estadoPago.slice()
            )
        );
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._filtroSrvc.filtrosOOTTLoaded$.subscribe((filtros) => {
                this.filtros = filtros;
            })
        );
    }

    agregarFiltro(
        event: MatChipInputEvent,
        controller: any,
        filtroSeleccionado: string
    ) {
        const input = event.input;
        const value = event.value;

        if ((value || "").trim()) {
            this._filtroSrvc.setFiltro(
                "filtrosOOTT",
                filtroSeleccionado,
                value.trim().toLowerCase(),
                value.trim().toLowerCase()
            );
        }

        if (input) {
            input.value = "";
        }

        controller.setValue(null);
    }

    quitarFiltro(nombreFiltro: string) {
        this._filtroSrvc.resetFiltro("filtrosOOTT", nombreFiltro);
    }

    seleccionarFiltro(
        event: MatAutocompleteSelectedEvent,
        columnaValor: string,
        columnaDescripcion: string,
        controller: any,
        input: string,
        filtroSeleccionado: string
    ) {
        //console.log(event.option.value);
        const valor = event.option.value[columnaValor];
        const descripcion = event.option.value[columnaDescripcion];

        this._filtroSrvc.setFiltro(
            "filtrosOOTT",
            filtroSeleccionado,
            valor,
            descripcion
        );
        this[input].nativeElement.value = "";
        controller.setValue(null);
        this.filtros = this._filtroSrvc.getFiltro("filtrosOOTT");
    }
    limpiarTodosFiltros() {
        this._filtroSrvc.initFiltrosOOTT();
        this.filtros = this._filtroSrvc.getFiltro("filtrosOOTT");
        this.filtrar();
    }

    private _filter(
        value: string | any,
        columnaAFiltrar: string,
        listaDeValoresAfiltrar: any[]
    ): any[] {
        //console.log(value);
        //console.log(columnaAFiltrar);
        let filterValue: string;
        if (typeof value === "object") {
            filterValue = value[columnaAFiltrar].toLowerCase();
        } else {
            filterValue = value.toLowerCase();
        }

        return listaDeValoresAfiltrar.filter((item) =>
            item[columnaAFiltrar].toLowerCase().includes(filterValue)
        );
    }

    filtrar() {
        this.filtrarOOTT.emit(this.filtros);
    }
    ngOnDestroy() {
        this.limpiarTodosFiltros();
        this.subscripciones.unsubscribe();
        //console.log("destoyed filtros oott!");
    }
}
